<template>
  <div class="recordings">
    <div class="search-and-sort-bar">
      <v-text-field
      v-model="search"
      name="search"
      label="Search"
      single-line
      prepend-icon="search"
      ></v-text-field>
    </div>
    <div class="loader" v-if="!fetched">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-list subheader v-else-if="allRecordings.length" three-line>
      <v-list-tile avatar v-for="recording in filteredRecordings" :key="recording._id" @click="visitRecording(recording)" class="hover-darken row">
        <v-list-tile-avatar tile class="recording-pic">
          <img
            :src="screenshotUrl(recording)"
            alt="Project Image"
            class="recording-screenshot"
          >
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="recording.name"></v-list-tile-title>
          <v-list-tile-sub-title class="text--primary">This is some description</v-list-tile-sub-title>
          <v-list-tile-sub-title>Other stuff</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-list-tile-title>{{recording.created | timeSince}}</v-list-tile-title>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-icon>more_vert</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <h1 class="no-recordings" v-else>
      No recordings in this project.
    </h1>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'Recordings',
  data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapState({
      allRecordings: state => _.sortBy(state.recordings.allRecordings, 'created').reverse(),
      issues: state => _.sortBy(state.issues.data, 'created').reverse(),
    }),
    ...mapGetters({
      currentProject: 'projects/currentProject',
      fetched: 'recordings/allRecordingsFetched',
    }),
    filteredRecordings() {
      return _.sortBy(this.allRecordings.filter(recording => recording.name.toLowerCase().includes(this.search.toLowerCase().trim())), 'created').reverse();
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store.dispatch('recordings/fetchAll', this.$route.params.projectId);
    },
    async visitRecording(recording) {
      this.$router.push({
        path: `/project/${this.currentProject._id}/recording/${recording._id}`,
      });
    },
    screenshotUrl(recording) {
      return _.get(recording, 'videos[0].screenshotUrl') || 'https://placehold.it/300/300';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1 {
  font-family: 'Karla', sans-serif;
  margin-left: 86px;
  font-size: 34px;
	font-weight: bold;
	line-height: 1.12;
}
.recording-pic {
  margin-left: 90px;
  width: 100px;
  img {
    max-height: 80px;
    width: 100px;
    height: auto;
  }
}
.row {
  padding: 25px 0px;
}
.no-recordings {
  text-align: center;
  padding-top: 50px;
}
/*start search and sort bar styling*/
.search-and-sort-bar {
  display: flex;
  flex-direction: row;
  margin-left: 25px;
  align-items: center;
  justify-content: flex-start;
  height: 100px;
  margin-right: 25px;
  .number-of-recordings {
    width: 120px;
    margin-right: 20px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Recordings.vue